import {DataFetcher} from '@aboutyou/data-fetcher';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {useHighTierCoupon} from '../useHighTierCoupon';

const CouponTopBannerView = lazy(() =>
  import('./CouponTopBannerView').then(module => ({
    default: module.CouponTopBannerView,
  })),
);

export const CouponTopBanner = () => {
  return (
    <DataFetcher
      request={useHighTierCoupon()}
      Error={null}
      View={CouponTopBannerView}
    />
  );
};
